module.exports = __webpack_public_path__ + "static/media/03_07_06.00b77c49.png";